import request, { queryWithSilentSilentSignin } from '@/utils/request'

const url_prefix = process.env.VUE_APP_API_URL

// 灵感大全数据
export function getPromptList(params) {
  return queryWithSilentSilentSignin(
    {
      url: `${url_prefix}/${params.url}`,
      method: 'get'
    },
    {
      loading: false,
      withToken: false
    }
  )
}

/**
 * @returns {Promise<{
 *  layout: "mix" | "cards" | "texts",
 *  cards: Array,
 *  cards: Array,
 * }>}
 */

export function getWelcomePageConfiguration(agentId) {
  return request(
    {
      // url: `${url_prefix}/feed-api/assistant/welcome_info/${agentId}`,
      url: `${url_prefix}/operation-api/assistant/welcome_info/${agentId}`,
      method: 'get'
    },
    {
      loading: false,
      withToken: true
    }
  ).then(result => {
    return result.result
  })
}
